import { SelectableRow } from "@common/SelectableRow/SelectableRow";
import { SimplePaymentMethodCardCell } from "@common/SimplePaymentMethodCardList/SimplePaymentMethodCardCell";
import { ISimplePaymentMethodCard } from "@common/SimplePaymentMethodCardList/ISimplePaymentMethodCard";
import { useStyle } from "./style";
import { Grid } from "@mui/material";

interface IParams {
    paymentMethod: ISimplePaymentMethodCard;
    index: number;
    selectedPaymentMethodCard: string | undefined;
    setSelectedPaymentMethodCard(paymentMethodCardId: string): void;
    dataLength: number;
}

export const SimplePaymentMethodCardRow = (props: IParams) => {
    const { paymentMethod, selectedPaymentMethodCard, setSelectedPaymentMethodCard, index, dataLength } = props;
    const { classes } = useStyle();

    const content = (
        <Grid className={classes.paymentMethodRow} container>
            <SimplePaymentMethodCardCell paymentMethod={paymentMethod} />
        </Grid>
    );

    return (
        <SelectableRow
            dataLength={dataLength}
            index={index}
            isSelected={selectedPaymentMethodCard === paymentMethod.providerReference}
            rowAriaLabel="payment-method-row"
            onSelect={() => setSelectedPaymentMethodCard(paymentMethod.providerReference)}
        >
            {content}
        </SelectableRow>
    );
};
